import { RestService } from "./RestService";
export class MoviePromotionValidityService extends RestService {
  constructor() {
    super("/api/v1/movie_promotions_validity");
  }
}
